<script lang="ts">
  import {getContext, onDestroy, onMount} from 'svelte';
  import {lang$} from '@/store';
  import {loginTelegram} from './stream';
  import {openRestrictedIP} from '@/modules/register/restricted-ip';
  import '../access-google/access-styled.scss';

  let className = '';
  export {className as class};
  export let scene = '';
  export let referralCode = '';
  export let entrance = '';
  export let group: string | number = '';
  export let target = '';
  export let width = 48;
  export let iconInfo = {
    defaultIcon: 'https://img.phemex.com/v1/7eea796c-7533-4d7b-8dcb-1e5fa22418eb/login-telegram.png',
    hoverIcon: 'https://img.phemex.com/v1/61378977-10f7-4d0d-9c0a-d1b48f81bd24/login-telegram-hover.png',
    alt: 'icon',
    visibleTitle: false,
  };

  const LG = getContext('LG');
  let initSubscription = null;
  let clickSubscription = null;
  const {state$, init, handleClick} = loginTelegram(target, referralCode, $lang$);

  onMount(async () => {
    initSubscription = init();
  });

  onDestroy(() => {
    initSubscription?.unsubscribe();
    clickSubscription?.unsubscribe();
  });

  async function handleBtnClick(event) {
    event.stopPropagation();
    const result = await openRestrictedIP({referralCode, LG, entrance});
    if (!result) {
      return;
    }
    clickSubscription = handleClick();
  }
</script>

<style>
  .loading {
    cursor: not-allowed;
    opacity: 0.5;
  }
</style>

<section class="wallet-connect-box">
  <div class="pr f16 df cp {className}" style="padding: 0" on:click={handleBtnClick}>
    <div class="df fdc jcc aic" class:loading={!$state$.ready || $state$.loading}>
      <div class="img df jcc aic pr">
        <img {width} height={width} data-replace-icon="false" src={iconInfo.defaultIcon} alt={iconInfo.alt} />
        <img {width} height={width} class="white" data-replace-icon="false" src={iconInfo.hoverIcon} alt={iconInfo.alt} />
      </div>
      {#if iconInfo.visibleTitle}
        <div class="con mt12 f12 lh18 T3 sm:hidden">Telegram</div>
      {/if}
    </div>
  </div>
</section>
